{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "inchat_booking",
  "x-feature": true,
  "x-cli-editable": true,
  "title": "In-Chat Booking",
  "description": "Collect the visitor's email and a few qualifying details inside the chat, then redirect them to your booking form pre-filled with their answers — so they finish scheduling without re-typing anything.",
  "type": "object",
  "properties": {
    "require_professional_email": {
      "ui:sectionTitle": "Booking",
      "ui:sectionDescription": "Email collection before a visitor books.",
      "ui:sectionIcon": "Calendar",
      "type": "boolean",
      "ui:tooltip": "Require a work email during booking.",
      "ui:description": "When on, the chatbot won't accept personal email addresses (Gmail, Yahoo, Outlook, etc.) during booking — it asks for a work email instead. After a couple of tries it accepts whatever the visitor gives so booking is never blocked. Turn off for B2C sites where personal emails are expected.",
      "default": true
    },
    "email_disclaimer": {
      "type": "object",
      "x-tier": "advanced",
      "ui:tooltip": "Small text shown below the email input when the chatbot asks the visitor to book a meeting.",
      "ui:description": "Add a privacy notice or legal text. To add a link, use [link text](https://example.com). Example: 'By providing your email you agree to our [privacy policy](https://example.com/privacy).' Leave empty to show no disclaimer.",
      "ui:keyPlaceholder": "en",
      "ui:addLabel": "Add language",
      "ui:keyHint": "Language or locale code (e.g. en, en-gb, fr)",
      "additionalProperties": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "default": {
    "require_professional_email": true
  }
}
